<template>
  <footer class="footer-pages">
    <div class="footer-travel"></div>
    <div class="back-all">
      <div class="back-3">
        <div class="backover"></div>
        <div class="container content">
          <div class="row justify-content-center">
            <div
              class="col-xl-4 col-lg-12 col-md-12 col-sm-6 content-footer align-self-center"
            >
              <img
                src="~rhomtrip_assets/src/img/brand/rhomtrip-v1p300.png"
                class="logo"
                alt="Logo Rhomtrip"
              />
              <span>Seamless Travel Experiences</span>
              <ul class="social-media">
                <li>
                  <a
                    href="https://www.linkedin.com/company/rhomtrip"
                    target="blank"
                  >
                    <i class="flaticon-bold flaticon-bold-linkedin"></i>
                  </a>
                </li>

                <li>
                  <a href="https://www.instagram.com/rhomtrip/" target="blank">
                    <i class="flaticon-bold flaticon-bold-instagram"></i>
                  </a>
                </li>
                <li>
                  <a href="https://www.facebook.com/rhomtrip" target="blank">
                    <i
                      class="flaticon-bold flaticon-bold-facebook-app-symbol"
                    ></i>
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.x.com/rhomtrip"
                    target="_blank"
                    aria-label="twitter RhomTrip"
                  >
                    <i class="flaticon-web-twitter-1"></i>
                  </a>
                </li>

                <li>
                  <a href="mailto:info@rhomtrip.com" target="_blank">
                    <i class="flaticon-envelope"></i>
                  </a>
                </li>

                <li>
                  <a href="https://rhomtrip.com/contact" target="blank">
                    <i class="flaticon-bold-telephone"></i>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="bottom-footer">
      <div class="container cont-footer">
        <div
          class="row justify-content-center border-top border-bottom pt-1 pb-1 mb-2"
        >
          <div class="col-xl-4 col-lg-5 col-md-8 col-sm-8 col-11">
            <div class="row">
              <div
                class="col-xl-3 col-lg-6 col-md-3 col-sm-3 col-3 align-self-center"
              >
                <a href="https://www.iata.org" target="_blank">
                  <img
                    class="img-fluid"
                    src="https://upcdn.io/FW25b8h/raw/signature/rhomtrip/rhomtrip-iata-code.png"
                    alt="iata-code"
                /></a>
              </div>
              <div
                class="col-xl-3 col-lg-6 col-md-3 col-sm-3 col-3 align-self-center"
              >
                <a href="https://www.asta.org/" target="_blank">
                  <img
                    class="img-fluid"
                    src="https://upcdn.io/FW25b8h/raw/signature/rhomtrip/asta-travel-advisors.png"
                    alt="asta"
                /></a>
              </div>
              <div
                class="col-xl-3 col-lg-6 col-md-3 col-sm-3 col-3 align-self-center"
              >
                <a href="https://www.octo.travel" target="_blank">
                  <img
                    class="img-fluid"
                    src="https://upcdn.io/FW25b8h/raw/signature/rhomtrip/octo-travel.png"
                    alt="octo"
                /></a>
              </div>
              <div
                class="col-xl-3 col-lg-6 col-md-3 col-sm-3 col-3 align-self-center"
              >
                <a href="https://www.tripadvisor.com" target="_blank">
                  <img
                    class="img-fluid"
                    src="~rhomtrip_assets/src/img/partnership/tripadvisor-2023.png"
                    alt="tripadvisor"
                /></a>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-12 text-center align-self-center">
          <p>
            Copyright © {{ systemInfo.year }}. RhomTrip OÜ™. Register Nº:
            14554819. All Rights Reserved.
          </p>
        </div>
      </div>
    </div>
  </footer>
</template>
<script>
import { mapGetters, mapMutations } from "vuex";
import COMMONS from "../Commons/URL/index";
export default {
  name: "layoutFooter",
  data() {
    return { linkPages: COMMONS };
  },
  methods: {
    ...mapMutations(["setSystemInfo"])
  },
  computed: {
    ...mapGetters(["systemInfo"])
  }
};
</script>
<style></style>
